import { useCallback, useSyncExternalStore } from 'react';

/** 옆 패널·일괄 편집처럼 넓은 화면을 전제로 한 UI를 켜는 기준 폭 — 태블릿 가로(1024px) 이상 */
export const WIDE_QUERY = '(min-width: 1024px)';

/** CSS 미디어쿼리 일치 여부 — 창 크기가 바뀌면 다시 그린다. */
export function useMediaQuery(query: string) {
  const subscribe = useCallback(
    (listener: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', listener);
      return () => {
        mql.removeEventListener('change', listener);
      };
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => true,
  );
}

export const useIsWide = () => useMediaQuery(WIDE_QUERY);
